import { getOfferUri } from '@/lib/offer';
import CollectionItemBox from '../../collections/CollectionItemBox';
import { CollectionItemWrapperProps } from './types';

const CollectionItemWrapper = (props: CollectionItemWrapperProps) => {
  const { offer, product: foundCollection } = props;
  const { psku, price, imageSrc } = offer;

  if (psku == null) return null;

  if (foundCollection == null) return null;

  const collectionImage = foundCollection.imageUrl || imageSrc || '';

  const productUrl = {
    ...getOfferUri(offer),
    pathname: `/collections/${foundCollection.handle}`,
  };

  return (
    <CollectionItemBox
      link={productUrl}
      image={collectionImage}
      title={foundCollection.title}
      price={price}
      fallbackImg={imageSrc}
    />
  );
};

export default CollectionItemWrapper;
